import { IConfigSeller } from '@/models/configSeller'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { TiDocumentAdd } from 'react-icons/ti'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { IAppStore } from '../../../../models/store.model'
import { webApiService } from '../../../../services'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useTradeinContext } from '../hooks/useTradeinContext'

const AddDocument = () => {
  const [data, setData] = useState<{ open: boolean, loading: boolean, documento: string, listCR: any[] }>({ open: false, loading: false, documento: '', listCR: [] })
  const { slug } = useParams()
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isWom = configSeller.config.s3.FOLDER_APP === 'ti_wom'

  const handleClose = () => {
    setData({ ...data, open: false, loading: false, documento: '' })
  }

  const handleSave = () => {
    setData({ ...data, loading: true })
    webApiService.updateDocument({ id_tradein: Number(ctx.tradein.id), id_user: userState.id, document_cupon_used: data.documento, seller: slug }).then(() => {
      enqueueSnackbar('Documento agregado correctamente', { variant: 'success' })
      setData({ ...data, loading: false, documento: '', open: false })
      saveCtx({ ...ctx, reload: true })
    }).catch((error) => {
      enqueueSnackbar('Hubo un error al agregar el documento', { variant: 'error' })
      setData({ ...data, loading: false })
      console.log('error ==>', error)
    })
  }

  return (
    <div>
      <Button
        size='sm'
        legacyColor='success'
        legacyVariant='shadow'
        onClick={() => { setData({ ...data, open: true }) }}
      >
        <TiDocumentAdd />
        Agregar Documento
      </Button>

      <Modal backdrop='blur' isOpen={data.open} onClose={handleClose}>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>Agregar Documento</ModalHeader>
          <ModalBody>
            <h4 className='text-lg mb-2 font-black'>{isWom ? 'Ingrese el documento (Número de ticket de compra MAT) donde se utulizó el cupón que genero el trade-in ' : 'Ingrese el documento (No. ticket de compra) donde se utulizó el cupón que genero el trade-in '}</h4>
            <Input
              value={data.documento}
              onChange={(e) => { setData({ ...data, documento: e.target.value }) }}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              variant='destructive'
              onClick={handleClose}
            >
              Cerrar
            </Button>
            <Button type='submit' disabled={data.documento === '' || data.loading} onClick={handleSave}>
              {data.loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  )
}

export default AddDocument
